import t from "./component-library273.js";
/* empty css                     */
import i from "./component-library98.js";
var l = function() {
  var a = this, s = a._self._c, e = a._self._setupProxy;
  return e.isDialogOpen ? s("dialog", { ref: "dialogElement", class: ["base-dialog", a.customClass], attrs: { id: `base-dialog-${e.uid}`, "aria-labelledby": a.$slots.header || a.headingText ? `base-dialog-heading-${e.uid}` : void 0, "aria-label": a.$slots.header ? void 0 : a.ariaLabel, "aria-describedby": `base-dialog-content-${e.uid}`, role: "dialog", "aria-modal": "true" }, on: { click: function(o) {
    return o.target !== o.currentTarget ? null : e.handleBackdropClick.apply(null, arguments);
  }, close: e.closeNative } }, [s("div", { ref: "dialogContainer", staticClass: "base-dialog__container", class: a.customContainerClass }, [s("div", { staticClass: "base-dialog__header", attrs: { id: `base-dialog-heading-${e.uid}` } }, [a._t("header", function() {
    return [a.headingText ? s(e.Heading, { attrs: { tag: "h3", size: "md" }, domProps: { innerHTML: a._s(a.headingText) } }) : a._e()];
  }, { close: e.closeDialog })], 2), s(e.LinkButton, { staticClass: "base-dialog__close", attrs: { autofocus: a.closeAutofocus, tag: "button", type: "button", transparent: "", "aria-label": "Fenster schließen", "icon-only": "" }, on: { click: e.closeDialog } }, [s("span", { staticClass: "base-dialog__close-icon" })]), s("div", { staticClass: "base-dialog__body", attrs: { id: `base-dialog-content-${e.uid}` } }, [a._t("default", null, { close: e.closeDialog })], 2), s("div", { staticClass: "base-dialog__footer" }, [a._t("footer", null, { close: e.closeDialog })], 2)], 1)]) : a._e();
}, n = [], r = /* @__PURE__ */ i(
  t,
  l,
  n,
  !1,
  null,
  "c352499b"
);
const u = r.exports;
export {
  u as default
};
